import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { updateFilters } from "../redux/clientProfileSearchSagas";

export const DatePicker = ({ title, slice: key }) => {
  const dispatch = useDispatch();
  const { calendarStartDate, calendarEndDate } = useSelector(
    (state) => state.clientProfilesSearch.currentUser
  );

  const { startDate, endDate } = useSelector(
    (state) => state.clientProfilesSearch.selectedFilters[key]
  );

  const handleUpdateDates = (startDate, endDate) => {
    dispatch(updateFilters({ data: { startDate, endDate }, key }));
  };

  return (
    <div className="filter">
      <p>{title}</p>
      <ReactDatePicker
        startDate={startDate}
        endDate={endDate}
        calendarEndDate={calendarEndDate}
        isRangePicker
        minDate={calendarStartDate}
        updateDates={handleUpdateDates}
      />
    </div>
  );
};
